







































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { SubTransactionTypesModule } from '@/store/Products/SubTransactionTypesModule';

@Component({ name: 'SubTransactionTypeDetails' })
export default class extends SaascadaVue {

    get subTransactionType() {
        return SubTransactionTypesModule.subTransactionType;
    }

}
